import { ElementState } from "@creatomate/preview";
import thresholdCheck from "./thresholdCheck";

const validateDragMagnet = (
  activeElementsId: string[],
  currentElement: ElementState,
  elements: ElementState[],
  magnetThreshold: number,
  onSetSnapTime: (value: number) => void,
  time: number
): boolean => {
  if (activeElementsId.length > 1) return false;

  const allElements = elements.filter(elmnt => elmnt.source.id !== currentElement.source.id);
  const { elementsStartValidation, elementsEndValidation } = thresholdCheck(magnetThreshold);

  const endTime = time + currentElement.duration;
  const isElementInThreshold = (elmnt: ElementState, time: number) => (
    elementsStartValidation(elmnt, time) || elementsEndValidation(elmnt, time)
    || elementsStartValidation(elmnt, endTime) || elementsEndValidation(elmnt, endTime)
  );

  // get the firts element that is on the threshold
  const thresholdElement = allElements?.find(elmnt => isElementInThreshold(elmnt, time));

  if (thresholdElement) {
    const snapTime = elementsStartValidation(thresholdElement, time)
      || elementsStartValidation(thresholdElement, time + currentElement.duration)
      ? thresholdElement.localTime : thresholdElement.localTime + thresholdElement.duration;
    onSetSnapTime(snapTime);
  }
  return !!thresholdElement;
};

export default validateDragMagnet;
